// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import IComponent from "./IComponent";

export interface IItemComponentList {
  [name: string]: IComponent;
}
